import { arrayFrom, findElems } from "./helpers";

function parsePhone(event : Event | FocusEvent, phone : HTMLInputElement) : void {
    let tempValue : string = phone.value.replace(/^\+(38)/g, '').replace(/\D+/g, ''),
        pattern : string = '+38 (___) ___-__-__';

    const oldSelectionStart : number = phone.selectionStart ?? 0,
        isInvalidSelectionStart : boolean = oldSelectionStart < 5,
        setSelection = (position : number) : void => {
            phone.selectionStart = position;
            phone.selectionEnd = position;
        },
        findPositionSelection = (string : string | undefined) => {
            let indexLetter : number = 0;

            if (!string) {
                string = pattern;
            }

            while (typeof string[indexLetter] !== 'undefined' && string[indexLetter] !== '_' && string.length > indexLetter) {
                indexLetter++;
            }

            return indexLetter;
        };

    for (let numberIndex : number = 0; numberIndex < tempValue.length; numberIndex++) {
        if (typeof tempValue[numberIndex] !== 'undefined') {
            pattern = pattern.replace(/_/, tempValue[numberIndex]);
        }
    }

    phone.value = pattern;

    if ('inputType' in event) {
        if (isInvalidSelectionStart && 'value' in event) {
            setSelection(findPositionSelection(event.value as string));
        }

        if (event.inputType === 'deleteContentBackward') {
            setSelection((isInvalidSelectionStart ? 5 : oldSelectionStart));
        } else if (event.inputType === 'insertText') {
            if (/\s/.test(pattern[oldSelectionStart] + pattern[oldSelectionStart + 1])) {
                setSelection(oldSelectionStart + 2);
            } else if (/[^_0-9]/.test(pattern[oldSelectionStart])) {
                setSelection(oldSelectionStart + 1);
            } else {
                setSelection(oldSelectionStart);
            }
        }
    } else if ('type' in event) {
        if (event.type === 'click' && isInvalidSelectionStart) {
            setSelection(5);
        } else if (event.type === 'focus' && isInvalidSelectionStart) {
            setSelection(findPositionSelection(pattern));
        }
    } else {
        setSelection(findPositionSelection(pattern));
    }
}

function handleParsePhoneNumber(inputsFieldsTelIdOrClassName : string = 'input[type=tel]') : void {
    arrayFrom(findElems(inputsFieldsTelIdOrClassName)).forEach((phone : HTMLElement) : void => {
        phone.addEventListener('input', (e : Event) => parsePhone(e, phone as HTMLInputElement));
        phone.addEventListener('focus', (e : FocusEvent) => parsePhone(e, phone as HTMLInputElement));
        phone.addEventListener('blur', (e : FocusEvent) => parsePhone(e, phone as HTMLInputElement));
        phone.addEventListener('click', (e : FocusEvent) => parsePhone(e, phone as HTMLInputElement));
    });
}

export { handleParsePhoneNumber };
